import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import SearchResultsSection from './SearchResultsSection'
import HitContainerHeader from './HitContainerHeader'
import {EventHit, Hit, DoSearch, GetItemPropsFn, AllSearchResults, ZendeskHit, SalesforceHit} from './index'
import SearchActionLink from './SearchActionLink'

type FederatedHits = Array<{hits: Array<EventHit | Hit | ZendeskHit | SalesforceHit>} | undefined>

interface Props {
  indexName: string,
  allSearchResults: AllSearchResults | null,
  inputValue: string,
  hits: FederatedHits,
  doSearch: DoSearch,
  highlightedIndex: number,
  getItemProps: GetItemPropsFn,
  style?: CSSStyleDeclaration,
  setHighlightedIndex: (idx: number | null) => void
}

const HitContainerWithFederated = ({
    indexName,
    allSearchResults,
    inputValue,
    hits,
    doSearch,
    highlightedIndex,
    getItemProps,
    setHighlightedIndex,
    style
  }: Props) => {

  const communitySearchMetadata = allSearchResults && allSearchResults[indexName]
  const zendeskSearchMetadata = allSearchResults && allSearchResults[`${indexName}-zendesk`]
  const salesforceSearchMetadata = allSearchResults && allSearchResults[`${indexName}-salesforce`]

  const communityHits = communitySearchMetadata ? communitySearchMetadata.hits : []
  const zendeskHits = zendeskSearchMetadata ? zendeskSearchMetadata.hits : []
  const salesforceHits = salesforceSearchMetadata ? salesforceSearchMetadata.hits : []

  const hasResults = communityHits.length || zendeskHits.length || salesforceHits.length

  return <div key='results' className='algolia-hit-container' style={style}>
    <HitContainerHeader
      inputValue={inputValue}
      hasResults={!!hasResults}
      doSearch={doSearch}
    />

    { communitySearchMetadata && communityHits
      ? <SearchResultsSection
        title={<Phrase p='nav.title.community' />}
        type='community'
        searchMetadata={communitySearchMetadata}
        hits={communityHits}
        highlightedIndex={highlightedIndex}
        getItemProps={getItemProps}
        previousResultsCount={0}
        setHighlightedIndex={setHighlightedIndex}
        viewAllUrl={`/search?q=${inputValue}`}
      /> : null }

    { zendeskSearchMetadata && zendeskHits && communityHits ? <SearchResultsSection
      title={<Phrase p='federated.search.zendesk' />}
      type='zendesk'
      searchMetadata={zendeskSearchMetadata}
      hits={zendeskHits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      setHighlightedIndex={setHighlightedIndex}
      previousResultsCount={communityHits.length}
      viewAllUrl={`/search?source=zendesk&q=${inputValue}`}
    /> : null }

    { salesforceSearchMetadata && salesforceHits && communityHits ? <SearchResultsSection
      title={<Phrase p='federated.search.salesforce' />}
      type='salesforce'
      searchMetadata={salesforceSearchMetadata}
      hits={salesforceHits}
      highlightedIndex={highlightedIndex}
      getItemProps={getItemProps}
      setHighlightedIndex={setHighlightedIndex}
      previousResultsCount={zendeskHits.length + communityHits.length}
      viewAllUrl={`/search?source=salesforce&q=${inputValue}`}
    /> : null }

    <SearchActionLink icon='edit' href='/topic/new'>
      <Phrase p='live.search.ask.question' />
    </SearchActionLink>
  </div>
}

export default HitContainerWithFederated
